import React from "react";
import AddCircleIcon from "@mui/icons-material/AddCircle";

function AddButtonRoundMobile(props) {
  return (
    <AddCircleIcon
      onClick={props.handleOpen}
      title={props.title}
      sx={{ color: "#1976d2", fontSize: 30 }} // Couleur bleue et taille de 60px
    />
  );
}

export default AddButtonRoundMobile;
